export default function (Vue) {
  const VueFirstCharacterFilter = (value) => {
    if (value || value === 0) {
      return value[0]
    }
  }

  Vue.filter('firstCharacter', VueFirstCharacterFilter)
}



// WEBPACK FOOTER //
// ./src/modules/filters/FirstCharacter.js